export class HapticFeedback {
  private static enabled = true;

  static setEnabled(enabled: boolean) {
    this.enabled = enabled;
    localStorage.setItem('haptic_enabled', enabled.toString());
  }

  static isEnabled(): boolean {
    const saved = localStorage.getItem('haptic_enabled');
    return saved !== null ? saved === 'true' : true;
  }

  static light() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate(10);
    }
  }

  static medium() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate(20);
    }
  }

  static heavy() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate([30, 10, 30]);
    }
  }

  static success() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate([10, 50, 10]);
    }
  }

  static error() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate([100, 50, 100]);
    }
  }

  static scan() {
    if (!this.enabled || !this.isEnabled()) return;
    
    if ('vibrate' in navigator) {
      navigator.vibrate(15);
    }
  }
}